export default function MySQL_CURDATE() {
  return (
    <div>
      <h2>MySQL_CURDATE</h2>    </div>
  );
}